import { Switch } from '@blueprintjs/core'
import * as React from 'react'
import Help from '../../../../../components/Help'
import { GenericCheckbox } from '../../../../../components/Inputs'
import { templateStyles } from './templateStyles'

export const Form = ({ input, onFormPreviewChange, index }) => {
  const props = input.get('props')

  const propsJS = props.toJS()
  const { helpText, ...childComponentProps } = propsJS

  return (
    <div>
      <GenericCheckbox
        onChange={v => onFormPreviewChange(index, v)}
        title={props.get('label')}
        requiredLabelStyle={templateStyles.requiredLabel}
        {...childComponentProps}
        required={propsJS.required && !propsJS.value}
      />
      {props.get('helpText') && (
        <Help>
          <div>{props.get('helpText')}</div>
        </Help>
      )}
    </div>
  )
}

export const Configuration = ({ input, onChange }) => {
  const inputProps = input.get('props')
  return (
    <div>
      <Switch
        checked={inputProps.get('value')}
        label="Default Checked"
        onChange={() => onChange('value', !inputProps.get('value'))}
      />

      <Switch
        checked={inputProps.get('alignRight')}
        label="Align Right"
        onChange={() => onChange('alignRight', !inputProps.get('alignRight'))}
      />
    </div>
  )
}
